<template>
  <div>
    <Hero/>
    <Features/>
    <ContentWithImage sectionName="create-everything-in-one-place" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_easy-to-get-started'" ext="png">
      <div class="easy-to-get-started">
        <ContentWithImage sectionName="easy-to-get-started" text-size="sm" justify-center image-order="0" image-order-sm="1" h2/>
      </div>
    </background-wrapper>
    <ContentWithImage sectionName="build-it-once-use-it-over-and-over-again" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo } from '@/components/ui/products'

export default {
  name: 'JobDescriptionGenerator',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass" scoped>
.easy-to-get-started
  padding-bottom: 100px
  +media-breakpoint-down(sm)
    padding-bottom: 10px
</style>



// WEBPACK FOOTER //
// src/components/products/JobDescriptionGenerator/JobDescriptionGenerator.vue